<template>
<div :style="'background:url(' + require('@/assets/bg-top-right.png') +') fixed '" style="margin-top:200px">
 
     <v-row v-if="items">
          <v-col cols="2" class="hidden-sm-and-down"></v-col>
          <v-col cols="12" lg="7" md="7" sm="12">
               <v-row>
                    <v-col cols="12">
                         <h1 class="titleStyle textSizeT  text-center">{{ localLang == 'fr' ?  items.title : items.titleAr }}</h1>
                    </v-col>
                    <v-col cols="12"  v-if="items.img != null">
                         <v-img aspect-ratio="2" cover :src="'news/' + items.img | URL"></v-img>
                    </v-col>
                    <v-col cols="12"> 
                         <p v-if="items.text1 != '/' || items.text1Ar != '/'" class="textSizeP container">
                              {{ localLang == 'fr' ? items.text1 : items.text1Ar }}
                         </p>
                         <p v-if="items.text2 != '/' || items.text2Ar != '/'" class="textSizeP container">
                              {{ localLang == 'fr' ? items.text2 : items.text2Ar }}
                         </p>
                         <p v-if="items.text3 != '/' || items.text3Ar != '/'" class="textSizeP container">
                              {{ localLang == 'fr' ? items.text3 : items.text3Ar }}
                         </p>
                         <p v-if="items.text4 != '/' || items.text4Ar != '/'" class="textSizeP container">
                              {{ localLang == 'fr' ? items.text4 : items.text4Ar }}
                         </p>
                    </v-col>
               </v-row>
          </v-col>
          <v-col cols="2" class="hidden-sm-and-down"></v-col>
     </v-row>
     <template v-else>
          <v-img aspect-ratio="2.5" contain :src="require('@/assets/404.png')"></v-img>
     </template>
</div>
</template>

<script>
export default {
     props: {
          id: Number
     },
data:() => ({ 
}),
computed: {
     items() {
          return this.$store.state.news.find(e => e.id == this.id)
     },
     
},
created() {  
     this.id = this.$route.params.id 
     
}
}
</script>

<style>

</style>
